module.exports = __webpack_public_path__ + "static/media/fly0291.989fcdae.webp";